import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PlaceAdministratorTableFilterSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/places/$id/_layout/administrators/')({
  validateSearch: zodValidator(PlaceAdministratorTableFilterSchema)
});